module.exports = __webpack_public_path__ + "img/Frame_24.25b0dc6b.png";